import { Suspense, StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import { Routing } from "./routing/Routing";
import { RouteChangePerformanceMark } from "./common/util/RouteChangePerformanceMark";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Suspense>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <RouteChangePerformanceMark />
          {Routing()}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </Suspense>,
);
